// hooks/useBoxes.js - Updated with refresh capability
import { boxService } from '../services/boxService';
import { useApi } from './useApi';

export function useBoxes() {
  return useApi(boxService.getBoxes, [], {
    onError: (error) => {
      console.error('Failed to fetch boxes:', error.message);
    }
  });
}

export function useBox(boxId) {
  return useApi(
    () => boxService.getBox(boxId),
    [boxId],
    { immediate: !!boxId }
  );
}

export function useBoxMeasurements(boxId, params = {}) {
  return useApi(
    () => boxService.getBoxMeasurements(boxId, params),
    [boxId, JSON.stringify(params)],
    { immediate: !!boxId }
  );
}

// Export the useCreateBox hook
export { useCreateBox } from './useCreateBox';